import { FAB, Icon, makeStyles, useTheme } from '@rneui/themed'
import React from 'react'

interface Props {
  setShowPinned: (val: boolean) => void
  descriptionHidden: boolean
  size?: number
}

export function PinnedButton({
  setShowPinned,
  descriptionHidden,
  size = 33,
}: Props) {
  const { theme } = useTheme()
  const styles = useStyles({ descriptionHidden, size })
  const pinnedIconColor = '#FFE2B3'

  const handlePress = () => {
    setShowPinned(true)
  }

  return (
    <FAB
      color={pinnedIconColor}
      placement="right"
      onPress={handlePress}
      style={styles.pinActionButton}
      buttonStyle={[
        styles.pinActionButtonContainer,
        { height: size, width: size },
      ]}
      icon={
        <Icon
          name="thumbtack"
          type="font-awesome-5"
          color={theme.colors?.white}
          size={size / 2}
          solid
        />
      }
    />
  )
}

const useStyles = makeStyles(
  (
    theme,
    { descriptionHidden, size }: { descriptionHidden: boolean; size: number }
  ) => ({
    pinActionButton: {
      position: descriptionHidden ? 'absolute' : 'relative',
      width: size,
      height: size,
      top: 0,
      margin: 10,
    },
    pinActionButtonContainer: { margin: 0, padding: 0 },
  })
)
